export default __webpack_public_path__ + "static/media/pumpkin-l4.6cf8e354.webp";